/* Pricing page corrections. v2.

   v2 (10 Oct 2026) keeps everything v1 did, unchanged, and adds a second
   block at the end of this file for the Monthly / Annual toggle:

   - Studio "Buy now" links carry &interval=year when Annual is selected, so
     the app's /buy page checks out the yearly plan. Monthly removes it.
   - Managed Starter, Growth and Business read "Talk to us" and go to
     /pages/contact when Annual is selected, until Managed annual checkout
     exists. Monthly puts back exactly the text and link they had.
   - Managed annual is 2 months free, not 15%: GBP 83 / 166 / 291 a month,
     the toggle badge, the FAQ answer and the note under the tables.
   - Every plan price, monthly and annual, in GBP, USD and EUR, matches
     what Stripe charges, on the cards and in the comparison tables.
   - Managed Enterprise reads "Talk to us", since it goes to the contact page.

   See the block's own header for how it stays correct under the currency
   picker. v1 is still in the theme and nothing references it.

   ---------------------------------------------------------------------- */
/* Pricing page corrections.

   templates/page.rockkt-pricing.liquid is 128KB and the Admin API can only
   replace a theme file whole, so it cannot be edited through this route. Same
   position as rockkt-home-v2.css, and the same answer: the corrections live in
   their own file. Loaded from layout/rockkt.liquid behind
   {% if template.suffix == 'rockkt-pricing' %}.

   Four things.

   1. AI credits, on the Managed cards, at the top.
      The numbers were already on the page, buried near the bottom of each
      feature list. They are lifted out of the list and set beside the seat
      count, which is where anyone comparing plans is actually looking. The
      figure is READ FROM THE CARD rather than written here, so this file can
      never disagree with the page. The Managed Enterprise card is the one
      exception: it carries no AI line at all, while the comparison table gives
      it Custom, so that is supplied here to stop the four cards contradicting
      each other.

   2. AI credits, on the Studio cards, where there were none at all.
      Studio runs two meters, not one. studio_credit_ledger.meter is either
      'credit' (a send) or 'lookup' (a paid AI action), and studio_company_
      settings carries monthly_credits and monthly_lookups separately. The page
      only ever showed the first. Lookups are granted at five times the send
      allowance: both live companies match exactly (free 5/25, s100 100/500),
      and that 5x is the ratio the Managed allowances were derived from too. So
      the figure is computed from the allowance already printed on the card
      rather than being a second list of numbers to keep in step.

      The top-up pack is skipped: it is an add-on, not a tier, and multiplying
      its pack size would invent an allowance that does not exist.

   3. SSO, which Rockkt does not offer, in three places.
   4. The negotiated rate, which does not need naming on a price card.

   The new line is given class "pr-users pr-ai": pr-users so it inherits the
   seat line's styling exactly rather than a guess at it, pr-ai as the hook and
   the idempotency guard. Nothing here needs a stylesheet.

   Everything is written to survive running twice, because the Studio/Managed
   switch and the monthly/annual toggle both re-enter the same markup. */
(function () {
  var LOOKUPS_PER_CREDIT = 5;

  function addLine(card, text) {
    if (card.querySelector('.pr-ai')) return;
    var users = card.querySelector('.pr-users');
    if (!users) return;
    var d = document.createElement('div');
    d.className = 'pr-users pr-ai';
    d.textContent = text;
    users.insertAdjacentElement('afterend', d);
  }

  function each(sel, fn) {
    var n = document.querySelectorAll(sel);
    for (var i = 0; i < n.length; i++) fn(n[i]);
  }

  function each2(list, fn) { for (var i = 0; i < list.length; i++) fn(list[i]); }

  function managed() {
    each('#pfFaceManaged .pr-card', function (card) {
      var found = null;
      each2(card.querySelectorAll('.pr-feats li'), function (li) {
        if (found) return;
        var span = li.querySelector('span');
        if (!span) return;
        var m = /^\s*([\d,]+)\s+AI credits\s*\/\s*month\s*$/i.exec(span.textContent);
        if (m) { found = m[1]; li.parentNode.removeChild(li); }
      });
      if (found) addLine(card, '⚡ ' + found + ' AI credits / month');
      else if (card.className.indexOf('t-enterprise') > -1) addLine(card, '⚡ Custom AI credit pool');
    });
  }

  function studio() {
    each('#pfFaceStudio .pr-card', function (card) {
      if (card.className.indexOf('t-topup') > -1) return;
      var cv = card.querySelector('.pr-credit .cv');
      if (!cv) return;
      var m = /^\s*([\d,]+)\s+credits?\s*$/i.exec(cv.textContent);
      if (m) {
        var n = parseInt(m[1].replace(/,/g, ''), 10) * LOOKUPS_PER_CREDIT;
        addLine(card, '⚡ ' + n.toLocaleString('en-GB') + ' AI credits / month');
      } else if (card.className.indexOf('t-senterprise') > -1) {
        addLine(card, '⚡ Custom AI credit pool');
      }
    });
  }

  function claims() {
    /* The Studio Enterprise price card. Was:
       "Negotiated rate - SSO, invoicing, SLA" */
    var cn = document.querySelector('#pfFaceStudio .t-senterprise .pr-credit .cn');
    if (cn && /SSO|Negotiated rate/i.test(cn.textContent)) {
      cn.textContent = 'Invoicing, PO terms and an SLA';
    }

    /* The note under the Studio grid. Trimmed rather than rewritten, so the
       rest of the sentence stays exactly as it was written. */
    var note = document.querySelector('#pfFaceStudio .pr-incl-note');
    if (note && note.textContent.indexOf('SSO') > -1) {
      note.textContent = note.textContent
        .replace('Enterprise adds SSO & 2FA, invoicing & PO terms', 'Enterprise adds invoicing & PO terms');
    }

    /* The "SSO & 2FA" row in the Studio comparison table. Removed rather than
       corrected: SSO does not exist, and 2FA is account level and available to
       everyone, so the row is wrong in both directions and there is nothing
       left in it once both are taken out. */
    each('.pr-compare tr', function (tr) {
      var td = tr.querySelector('td');
      if (td && /^\s*SSO\b/i.test(td.textContent) && tr.parentNode) {
        tr.parentNode.removeChild(tr);
      }
    });
  }

  function run() {
    managed();
    studio();
    claims();
    /* The flip stage sets its own height in JS from the taller face, so it has
       to be told the cards just grew or it will clip the last line. */
    try { window.dispatchEvent(new Event('resize')); } catch (e) {}
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  window.addEventListener('load', run);
})();


/* ---------------------------------------------------------------------
   v2: the Monthly / Annual toggle, and every plan price in every currency.

   The template's own toggle (applyBill, in the inline script) only swaps the
   price text and the "billed monthly / annually" line. It never touched the
   buttons, so a visitor who chose Annual was sent to the monthly checkout.

   Everything here is a pure function of three things read from the page:
   which billing button is .active in #prBill, which currency button is
   aria-pressed in the picker, and the original href/text of each button
   (remembered once, in data attributes). apply() writes only what differs,
   so it can run any number of times, in any order, and lands in the same
   state. One MutationObserver re-runs it after anything else on the page
   writes: the template's applyBill, the flip (which sets the badge back to
   "SAVE 15%"), the currency picker's repaints at 1.5s and 4s, and
   rockkt-overrides-v1.js on load.

   PRICES. Stripe is the source of truth. The currency picker converts any
   "£n" through one fixed table keyed on the GBP figure, which cannot be right
   when two plans share a GBP price but not a USD one (£199 is $279 on Studio
   250 and $269 on Managed Growth), and it was also simply wrong in places
   (Managed Starter $139, Studio 500 €449). So every plan price on the page is
   marked data-rk-nocc, which the picker already honours, and painted here
   from PLANS below: the cards, the Studio comparison table's two price rows,
   the Studio or Managed table's starting prices and the Managed strip.
   Studio annual is the Stripe yearly price / 12, rounded. Managed annual is
   monthly x 10 / 12, rounded (no yearly Stripe price yet).

   Prices this does NOT paint, because Stripe has no plan price for them and
   the picker's figures are left as they were: the £25 top-up pack and the
   £300 suggested gift credit.
   --------------------------------------------------------------------- */
(function () {
  var BUY = 'https://app.rockkt.com/buy?plan=';
  var YEAR = 'interval=year';
  var CONTACT = '/pages/contact';
  var TALK = 'Talk to us';
  var SYM = { GBP: '£', USD: '$', EUR: '€' };

  /* Stripe live prices, 10 Oct 2026. Studio: [monthly, yearly].
     Managed: monthly only. */
  var STRIPE = {
    s25:      { GBP: [29, 290],   USD: [39, 390],   EUR: [35, 350] },
    s50:      { GBP: [49, 490],   USD: [69, 690],   EUR: [59, 590] },
    s100:     { GBP: [89, 890],   USD: [119, 1190], EUR: [109, 1090] },
    s250:     { GBP: [199, 1990], USD: [279, 2790], EUR: [239, 2390] },
    s500:     { GBP: [379, 3790], USD: [519, 5190], EUR: [459, 4590] },
    core:     { GBP: [99],  USD: [129], EUR: [119] },
    growth:   { GBP: [199], USD: [269], EUR: [239] },
    advanced: { GBP: [349], USD: [469], EUR: [419] }
  };
  var CARD = {
    't-sstarter': 's25', 't-score': 's50', 't-sgrowth': 's100',
    't-sbusiness': 's250', 't-sscale': 's500',
    't-starter': 'core', 't-growth': 'growth', 't-business': 'advanced'
  };
  var STUDIO_COLS = ['s25', 's50', 's100', 's250', 's500'];   /* table columns 2 to 6 */

  /* The figure shown per month, as a string. */
  function price(plan, cur, annual) {
    var p = STRIPE[plan][cur];
    if (!annual) return String(p[0]);
    if (p.length > 1) return String(Math.round(p[1] / 12));
    return String(Math.round(p[0] * 10 / 12));
  }
  function money(plan, cur, annual) { return SYM[cur] + price(plan, cur, annual); }

  function mode() {
    var b = document.querySelector('#prBill button.active');
    return b && b.getAttribute('data-bill') === 'annual' ? 'annual' : 'monthly';
  }

  function currency() {
    var b = document.querySelector('footer .rk-ccy button[aria-pressed="true"]') ||
            document.querySelector('.rk-ccy button[aria-pressed="true"]');
    var c = b && b.getAttribute('data-ccy');
    if (c && SYM[c]) return c;
    var code = document.querySelector('.rk-ccode');
    c = code && code.textContent.trim().toUpperCase();
    return c && SYM[c] ? c : 'GBP';
  }

  function setText(el, t) { if (el && el.textContent !== t) el.textContent = t; }
  function setAttr(el, k, v) { if (el && el.getAttribute(k) !== v) el.setAttribute(k, v); }
  /* Take an element away from the currency picker and write it ourselves. */
  function paint(el, t) { if (!el) return; setAttr(el, 'data-rk-nocc', ''); setText(el, t); }

  function planOf(card) {
    for (var k in CARD) if ((' ' + card.className + ' ').indexOf(' ' + k + ' ') > -1) return CARD[k];
    return null;
  }

  /* The price on every paid Studio and Managed card. */
  function cards(annual, cur) {
    var all = document.querySelectorAll('#pfFaceStudio .pr-card, #pfFaceManaged .pr-card');
    for (var i = 0; i < all.length; i++) {
      var plan = planOf(all[i]);
      if (!plan) continue;
      var amt = all[i].querySelector('.pr-price .amt');
      if (!amt) continue;
      /* GBP in the template's own attributes too, so its toggle writes the
         right figure even before this runs. */
      setAttr(amt, 'data-m', money(plan, 'GBP', false));
      setAttr(amt, 'data-a', money(plan, 'GBP', true));
      paint(amt, money(plan, cur, annual));
    }
  }

  /* Every other place on the page that prints a plan price. These are fixed
     comparisons, so they do not follow the toggle: the "Annual" row is always
     annual and everything else is always monthly. */
  function elsewhere(cur) {
    var rows = document.querySelectorAll('table.pr-compare tr');
    for (var i = 0; i < rows.length; i++) {
      var td = rows[i].querySelectorAll('td');
      if (!td.length) continue;
      var label = td[0].textContent.trim();
      if (/^Price per month$/i.test(label) && td.length >= 7) {
        for (var c = 0; c < 5; c++) paint(td[c + 2], money(STUDIO_COLS[c], cur, false));
      } else if (/^Annual \(2 months free\)$/i.test(label) && td.length >= 7) {
        for (var d = 0; d < 5; d++) paint(td[d + 2], money(STUDIO_COLS[d], cur, true) + '/mo');
      } else if (/^Starting price$/i.test(label) && td.length >= 3) {
        paint(td[1], SYM[cur] + '0, then ' + money('s25', cur, false) + '/mo');
        paint(td[2], money('core', cur, false) + '/mo + gift credit');
      }
    }
    /* "from £99/mo" on the Managed strip: the bold that carries a figure. */
    var bs = document.querySelectorAll('.pf-strip.m b');
    for (var j = 0; j < bs.length; j++) {
      if (bs[j].hasAttribute('data-rk-nocc') || /\d/.test(bs[j].textContent)) {
        paint(bs[j], money('core', cur, false) + '/mo');
      }
    }
  }

  /* Studio: add or remove &interval=year on every /buy link. */
  function studioLinks(annual) {
    var ctas = document.querySelectorAll('#pfFaceStudio .pr-card .pr-cta');
    for (var i = 0; i < ctas.length; i++) {
      var a = ctas[i], card = a.closest('.pr-card');
      if (!card || /\bt-(sfree|topup|senterprise)\b/.test(card.className)) continue;
      var orig = a.getAttribute('data-rk-href');
      if (orig === null) {
        var h = a.getAttribute('href') || '';
        if (h.indexOf(BUY) !== 0) continue;
        /* Never remember a link that already has the yearly flag on it. */
        orig = h.replace(/[?&]interval=year(?=&|$)/, '');
        a.setAttribute('data-rk-href', orig);
      }
      setAttr(a, 'href', annual ? orig + (orig.indexOf('?') > -1 ? '&' : '?') + YEAR : orig);
    }
  }

  /* Managed: the three plan buttons, and Enterprise. */
  function managedLinks(annual) {
    var tiers = ['t-starter', 't-growth', 't-business'];
    for (var i = 0; i < tiers.length; i++) {
      var a = document.querySelector('#pfFaceManaged .pr-card.' + tiers[i] + ' .pr-cta');
      if (!a) continue;
      if (a.getAttribute('data-rk-href') === null) {
        a.setAttribute('data-rk-href', a.getAttribute('href') || '');
      }
      /* The original text is taken while Monthly is showing, and refreshed if
         something else renames the button on Monthly (rockkt-overrides-v1.js
         turns "Get started" into "Buy now" on DOMContentLoaded and load). */
      var t = a.textContent.trim();
      if (!annual && t !== TALK) a.setAttribute('data-rk-text', t);
      if (annual) {
        setAttr(a, 'href', CONTACT);
        setText(a, TALK);
      } else {
        setAttr(a, 'href', a.getAttribute('data-rk-href'));
        var back = a.getAttribute('data-rk-text');
        if (back) setText(a, back);
      }
    }
    /* Enterprise goes to the contact page, so it says so, in both modes. */
    setText(document.querySelector('#pfFaceManaged .pr-card.t-enterprise .pr-cta'), TALK);
  }

  /* Wording: 2 months free on Managed too, wherever 15% was said. */
  function wording() {
    setText(document.getElementById('pfSave'), '2 MONTHS FREE');

    var ans = document.querySelectorAll('.pr-q .ans');
    for (var i = 0; i < ans.length; i++) {
      var html = ans[i].innerHTML;
      var next = html.replace(
        /Managed annual\s*<span class="hl">\s*saves 15%\s*<\/span>\s*on your platform fee/,
        'Managed annual also gives you <span class="hl">2 months free</span> (pay for 10, get 12)');
      if (next !== html) ans[i].innerHTML = next;
    }

    var note = document.querySelector('.pr-note');
    if (note && note.textContent.indexOf('save 15%') > -1) {
      var w = document.createTreeWalker(note, NodeFilter.SHOW_TEXT, null), n;
      while ((n = w.nextNode())) {
        if (n.nodeValue.indexOf('pay annually and save 15% on your platform fee') > -1) {
          n.nodeValue = n.nodeValue.replace('pay annually and save 15% on your platform fee',
            'pay annually and get 2 months free (pay for 10, get 12)');
        }
      }
    }
  }

  var obs = null;

  function apply() {
    if (obs) obs.disconnect();
    try {
      var annual = mode() === 'annual', cur = currency();
      cards(annual, cur);
      elsewhere(cur);
      studioLinks(annual);
      managedLinks(annual);
      wording();
    } catch (e) {}
    if (obs) {
      obs.takeRecords();
      obs.observe(document.body, {
        subtree: true, childList: true, characterData: true,
        attributes: true, attributeFilter: ['aria-pressed', 'class']
      });
    }
  }

  function start() {
    if (!document.body) return;
    if ('MutationObserver' in window && !obs) obs = new MutationObserver(apply);
    apply();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  window.addEventListener('load', apply);
})();
